import React from "react";
import { useGlobalContext } from "context/global";
import Loader from "components/loader";

const PlaceOrder = ({ onCancel, isSubmitting, handlePlaceOrder }) => {
	const { translation } = useGlobalContext();

	const title = translation.subscription?.reschedule_confirm_title;
	const description = translation.subscription?.reschedule_confirm_desc;

	return (
		<div className="min-h-64 flex flex-col gap-5">
			<div className="my-10 flex flex-col gap-3">
				{title && <h4 className="text-center">{title}</h4>}
				{description && <p className="text-secondary">{description}</p>}
			</div>
			<div className="flex flex-col items-center mx-auto justify-center gap-4">
				{isSubmitting ? <div className="min-h-12"> <Loader ring className="!size-7" /></div> :
					<button onClick={handlePlaceOrder} className="btn-primary">
						{translation.other?.confirm}
					</button>}
			</div>
			<button onClick={onCancel} className="underline">
				{translation.other?.cancel}
			</button>
		</div>
	);
};

export default PlaceOrder;